import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import styles from "./index.module.scss";
import PageMarker from "../../../ADP/PageMarker";
import { useClientFileContext } from "../../../../contexts/ClientFileProvider";
import Button from "../../../Button";
import Modal from "../../../Modal";
import UploadDocumentsModal from "../../../ADP/UploadDocumentsModal";
import Tooltip from "../../../Tooltip";
import CheckboxGroup from "../../../CheckboxGroup";
import CommentGroup from "../../../ADP/CommentGroup";

const Section4Alt = () => {
  const [isUploadModalOpen, setUploadModalOpen] = useState(false);
  const { clientFile, formMode: mode } = useClientFileContext();
  const { setValue } = useFormContext();

  const section1 = useWatch({ name: "info.section1-touched" }) ? "4-s1" : undefined;
  const section2a = useWatch({ name: "info.section2a-show" }) ? "4-s2a" : undefined;
  const section2b = useWatch({ name: "info.section2b-show" }) ? "4-s2b" : undefined;
  const section2c = useWatch({ name: "info.section2c-show" }) ? "4-s2c" : undefined;
  const section2d = useWatch({ name: "info.section2d-show" }) ? "4-s2d" : undefined;
  const section3and4 = useWatch({ name: "info.section3-touched" }) ? "4-s3s4" : undefined;

  const attachments = useWatch({ name: "section4Alt.attachments" });

  useEffect(() => {
    setValue("section4Alt.sections", []);
    setValue("section4Alt.sections", [section1, section2a, section2b, section2c, section2d, section3and4]);
    setValue("section4.s1", section1 === "4-s1");
    setValue("section4.s2a", section2a === "4-s2a");
    setValue("section4.s2b", section2b === "4-s2b");
    setValue("section4.s2c", section2c === "4-s2c");
    setValue("section4.s2d", section2d === "4-s2d");
    setValue("section4.s3s4", section3and4 === "4-s3s4");
  }, [setValue, section1, section2a, section2b, section2c, section2d, section3and4]);

  useEffect(() => {
    if (attachments) {
      setValue("section4.attachment-justification-funding-chart", attachments.find((x: string) => x === "4-attachment-justification-funding-chart") !== undefined);
      setValue("section4.attachment-special-circumstances", attachments.find((x: string) => x === "4-attachment-special-circumstances") !== undefined);
      setValue("section4.attachment-vendor-quote-replacement", attachments.find((x: string) => x === "4-attachment-vendor-quote-replacement") !== undefined);
      setValue("section4.attachment-vendor-quote-custom-mods", attachments.find((x: string) => x === "4-attachment-vendor-quote-custom-mods") !== undefined);
    };
  }, [setValue, attachments]);

  const sectionOptions = [
    {
      label: "Section 1 – Applicant’s Biographical Information & Confirmation of Eligibility (Section 1 must be completed and submitted)",
      value: "4-s1",
    },
    {
      label: "Section 2a – Ambulation Aids",
      value: "4-s2a",
    },
    {
      label: "Section 2b – Manual Wheelchairs",
      value: "4-s2b",
    },
    {
      label: "Section 2c – Power Bases and Power Scooters",
      value: "4-s2c",
    },
    {
      label: "Section 2d – Positioning Devices (Seating) for Mobility",
      value: "4-s2d",
    },
    {
      label: "Section 3 and Section 4 – Consent and Signatures (Sections 3 and 4 must be completed and submitted)",
      value: "4-s3s4",
    },
  ];

  const attachmentOptions = [
    {
      label: "Vendor Quote - Replacement of ADP funded equipment due to normal wear and tear",
      value: "4-attachment-vendor-quote-replacement",
    },
    {
      label: "Vendor Quote - Custom Modifications to ADP Listed Device",
      value: "4-attachment-vendor-quote-custom-mods",
    },
    {
      label: "Justification for Funding Chart - Dynamic Positioning Device (power tilt and/or recline and/or power elevating leg rests)",
      value: "4-attachment-justification-funding-chart",
    },
    {
      label: "Letter of Rationale - Extenuating Circumstances Only",
      value: "4-attachment-special-circumstances",
    },
  ];

  const readOnly = (mode === "locked");

  return (
    <>
      <PageMarker page={13} total={13} />
      <CommentGroup
        section="section4Alt"
        id="1-note-to-adp"
        className={styles.margin}
        locked={mode === "locked"}
        readOnly={clientFile.status === "PendingSignature"}
      >
        <div className={styles["section-container"]}>
          <p>Note to ADP Registered Authorizer:</p>
          <br/>
          <p>
            <strong>1. Complete this application form in full according to applicant’s eligibility for ADP funding assistance and make a copy for your records.</strong>
          </p>
          <br/>
          <CheckboxGroup
            section="section4Alt"
            options={sectionOptions}
            name="sections"
            label="2. Check the following pages/sections of the application form and the attachments that are included with your submission:"
            readOnly
          />
          <br/>
          <CheckboxGroup
            section="section4Alt"
            options={attachmentOptions}
            name="attachments"
            label="3. Attachments (if required) Note: Other attachments will not be considered by the Assistive Devices Program"
            readOnly={mode !== "edit"}
            tooltip={
              <Tooltip
                id="section-4-alt-tooltip"
                content="Please select all attachments that are part of this ADP application. Please select all attachments needed, regardless of whether they are currently uploaded in Motion EASI."
              />
            }
          />
          <div className={styles["button-container"]}>
            <Button
              className={styles.uploadButton}
              secondary
              onClick={() => setUploadModalOpen(true)}
              disabled={readOnly && false}
            >
              Upload/View All Documents
            </Button>
          </div>
          <p>
            <strong>4. Application form may be submitted to ADP once all signatures are obtained – applicant/agent, authorizer and vendor(s).</strong>
          </p>
        </div>
      </CommentGroup>
      <Modal
        title="Supporting Documents"
        isOpen={isUploadModalOpen}
        onClose={() => {
          setUploadModalOpen(false);
        }}
      >
        <UploadDocumentsModal
          clientFileId={clientFile.id}
          setUploadModalOpen={setUploadModalOpen}
        />
      </Modal>
    </>
  );
};

export default Section4Alt;
